
import styles from "../HealthChat.module.css";

/* ─── SVG icons ─────────────────────────────────────────────────────────── */
const CalendarIcon = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const StethoscopeIcon = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 6.5a4 4 0 0 0 8 0V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v2.5z" />
    <path d="M8.5 10.5v4a5 5 0 0 0 10 0v-1" />
    <circle cx="19" cy="12" r="1.5" fill="var(--primary-color)" />
  </svg>
);

const HeartHandsIcon = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

/* ─── Copy per language ─────────────────────────────────────────────────── */
const COPY = {
  en: {
    title: "What would you like to do next?",
    subtitle: "Choose an option to continue your care journey",
    actions: [
      { id: "book",     label: "Book an Appointment",  desc: "Schedule a consultation with a women's health specialist" },
      { id: "symptoms", label: "Check Symptoms",        desc: "Learn more about specific symptoms and get personalized guidance" },
      { id: "programs", label: "Health Programs",       desc: "Explore wellness programs designed for your stage of life" },
    ],
  },
  hi: {
    title: "आप आगे क्या करना चाहेंगी?",
    subtitle: "अपनी देखभाल यात्रा जारी रखने के लिए एक विकल्प चुनें",
    actions: [
      { id: "book",     label: "अपॉइंटमेंट बुक करें", desc: "महिला स्वास्थ्य विशेषज्ञ से परामर्श का समय निर्धारित करें" },
      { id: "symptoms", label: "लक्षण जांचें",          desc: "विशिष्ट लक्षणों के बारे में अधिक जानें" },
      { id: "programs", label: "स्वास्थ्य कार्यक्रम",    desc: "आपके जीवन के इस चरण के लिए वेलनेस कार्यक्रम देखें" },
    ],
  },
  te: {
    title: "మీరు తదుపరి ఏమి చేయాలనుకుంటున్నారు?",
    subtitle: "మీ కేర్ జర్నీ కొనసాగించడానికి ఒక ఎంపిక చేసుకోండి",
    actions: [
      { id: "book",     label: "అపాయింట్మెంట్ బుక్ చేయండి", desc: "మహిళా ఆరోగ్య నిపుణుడితో సంప్రదింపు షెడ్యూల్ చేయండి" },
      { id: "symptoms", label: "లక్షణాలు తనిఖీ చేయండి",       desc: "నిర్దిష్ట లక్షణాల గురించి మరింత తెలుసుకోండి" },
      { id: "programs", label: "ఆరోగ్య కార్యక్రమాలు",          desc: "మీ జీవిత దశకు తగిన వెల్నెస్ కార్యక్రమాలు చూడండి" },
    ],
  },
};

const ICONS = {
  book:     CalendarIcon,
  symptoms: StethoscopeIcon,
  programs: HeartHandsIcon,
};

/* ─── Component ─────────────────────────────────────────────────────────── */
export default function WhatNextScreen({ lang = "en", onSelect }) {
  const c = COPY[lang] || COPY.en;

  return (
    <div className={styles.whatNextScreen}>
      <div className={styles.whatNextTitle}>{c.title}</div>
      <div className={styles.whatNextSub}>{c.subtitle}</div>

      <div className={styles.whatNextGrid}>
        {c.actions.map(({ id, label, desc }) => {
          const Icon = ICONS[id];
          return (
            <div
              key={id}
              className={styles.whatNextCard}
              onClick={() => onSelect(id)}
            >
              <div className={styles.whatNextCardIcon}>
                <Icon size={38} />
              </div>
              <div className={styles.whatNextCardLabel}>{label}</div>
              <div className={styles.whatNextCardDesc}>{desc}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
